import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const productsCompareRootSelector = createFeatureSelector('productsCompare');

const getCompareLoading = createSelector(
  productsCompareRootSelector,
  (state) => state?.loading || { manage: 'none', loadData: 'none' },
);

export const getManageLoading = createSelector(getCompareLoading, (loading) => loading.manage);

export const getUserActionLoading = createSelector(
  productsCompareRootSelector,
  (state) => state?.userActionLoading || false,
);
